import ClubJoinList from "src/components/ManageClubJoin/ClubJoinList";

export default function ManageClubJoin() {
  return (
    <div>
      <ClubJoinList/>
    </div>
  )
}